import { render, staticRenderFns } from "./ContributionsEdit.vue?vue&type=template&id=4757c0eb&scoped=true"
import script from "./ContributionsEdit.vue?vue&type=script&lang=ts"
export * from "./ContributionsEdit.vue?vue&type=script&lang=ts"
import style0 from "./ContributionsEdit.vue?vue&type=style&index=0&id=4757c0eb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4757c0eb",
  null
  
)

export default component.exports